import Vue from 'vue'
import VueProgressBar from 'vue-progressbar'

const options = {
    color: '#ff6f29',
    failedColor: '#BB2B43',
    thickness: '2px',
    transition: {
        speed: '0.5s',
        opacity: '0.5s',
        termination: 300
    },
    autoRevert: true,
    location: 'top',
    inverse: false
};

Vue.use(VueProgressBar, options);
